import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { HeaderOneComponent } from '../../shared/header/header-one/header-one.component';
import { FooterMoreInfoComponent } from '../../home/landing-root/footer-more-info/footer-more-info.component';
@Component({
  standalone: true,
  selector: 'app-job-seeker',
  templateUrl: './job-seeker.component.html',
  styleUrl: './job-seeker.component.scss',
  imports: [RouterModule, CommonModule, HeaderOneComponent, FooterMoreInfoComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class JobSeekerComponent {
  [key: string]: any;
  constructor() {
  }


}
